import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { setItemInPersistentStore, getItemFromPersistentStore, getUserDetails } from '../../../../common/utils/Persist';

const useAuthTokenHandler = () => {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const searchParams = new URLSearchParams(location.search);
      const accessToken = searchParams.get('access_token');
      const loginType = searchParams.get('loginType');
      if (accessToken) {
        setItemInPersistentStore('access_token', accessToken);
        setItemInPersistentStore('isLoggedIn', true);
        setItemInPersistentStore('loginType', loginType);
      }
    } catch (error) {
      console.error('Error parsing URL parameters:', error);
    } finally {
      const loggedIn = getUserDetails('uifReadable', false) || getItemFromPersistentStore('isLoggedIn', false);
      setIsLoggedIn(!!loggedIn);
      setCheckingAuth(false);
    }
  }, []);

  return { checkingAuth, isLoggedIn };
};

export default useAuthTokenHandler;
